import {ControlledAutocompleteSelect} from '@hm/fundamental'
import {useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {useLocationOptions} from '../../hooks/useLocationOptions'
import {useHierarchyIdFromURL} from '../Base/header/PlantSelectButton/useHierarchyIdFromUrl'

export const InvalidSelectionLocationPicker: React.FC = () => {
  const {t} = useTranslation()
  const [hierarchyId, setHierarchyId] = useHierarchyIdFromURL()
  const {options, isLoading} = useLocationOptions()
  const [filterQuery, setFilterQuery] = useState('')

  const sortedOptions = useMemo(
    () => [...options].sort((a, b) => a.name.localeCompare(b.name)),
    [options]
  )

  const filteredOptions = useMemo(() => {
    const query = filterQuery.trim().toLowerCase()
    if (!query) return sortedOptions
    return sortedOptions.filter((option) => option.name.toLowerCase().includes(query))
  }, [sortedOptions, filterQuery])

  return (
    <div className="mt-4 w-full max-w-[420px]" data-test-id="invalid_selection_location_picker">
      <ControlledAutocompleteSelect
        label={t('suite.invalidSelection.locationPlaceholder')}
        options={filteredOptions.map((option) => ({label: option.name, value: option.id}))}
        selectedValues={hierarchyId ? [hierarchyId] : []}
        onChange={(values) => {
          const val = values[values.length - 1]
          if (val) setHierarchyId(String(val))
        }}
        onFilterChange={(query) => setFilterQuery(query)}
        isDisabled={isLoading || sortedOptions.length === 0}
        data-cy="invalid_selection_location_picker_select"
      />
    </div>
  )
}
